/*
 * Copyright (c) Nexign, JSC, 2022-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.19.0
 */

export interface ITableDefaultInquiry {
    account: {
        id: number;
        number: string;
    };
    branch?: string;
    closeDate: string;
    createDate: string;
    description?: string;
    id: string;
    status: string;
    statusId: number;
    subscriberNumber?: string;
    topic: string;
    updateDate: string;
}

export interface ITableOtherInquiry {
    account: {
        id: number;
        number: string;
    };
    branch?: string;
    closeDate: string;
    createDate: string;
    id: string;
    status: string;
    statusId: number;
    subscriberNumber?: string;
    topic: string;
    updateDate: string;
    processingReport: string;
}

export enum EInquiryTableType {
    DEFAULT = 'DEFAULT',
    OTHER = 'OTHER',
}
